<template>
    <q-dialog v-model="showModal" persistent>
        <q-card class="card-shadow">
            <q-item class="bg-positive">
                <q-item-section side>
                    <q-icon name="fa fa-edit" color="white" v-if="transactionId"/>
                    <q-icon name="fa fa-plus" color="white" v-else/>
                </q-item-section>

                <q-item-section>
                    <q-item-label lines="1" class="text-white">{{transactionId ? 'Edit' : 'New'}} Incoming Transaction</q-item-label>
                </q-item-section>
            </q-item>

            <q-card-section>
                <incoming-transaction-form
                    v-model="transaction"
                    :saving="loading"
                    @referenced="makeTransactionByReference"
                    :references="references"
                />
                <q-inner-loading :showing="loading">
                    <q-spinner-gears size="50px" color="input-color" />
                </q-inner-loading>
            </q-card-section>

            <q-card-actions class="flex justify-end">
                <q-btn color="cancel-btn" flat label="Cancel" v-close-popup />
                <q-btn color="positive" icon="fa fa-save" label="Save" @click="saveTransaction" :loading="loading" :disabled="! (transaction.amount && transaction.bank_date)" />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>
<script>

import {TransactionMixin} from '../mixins/TransactionMixin'
import Transfer from "Modules/Transfer/resources/models/Transfer"
import IncomingTransactionForm from "../components/IncomingTransactionForm"

export default {
    name: "IncomingTransactionModal",
    mixins: [TransactionMixin],
    model: {
        prop: 'open',
        event: 'change'
    },
    props: {
        open: {
            type: Boolean,
            default: false
        },
        transactionId: {
            type: Number,
            default: 0
        },
        reference: {
            type: String,
            required: false
        }
    },
    computed: {
        showModal: {
            get: function () {
                return this.open
            },
            set: function (value) {
                this.$emit('change', value)
            }
        },
    },
    data() {
        return {
            loading: false,
            transaction: this.initialize( 'credit'),
            references: []
        }
    },
    methods: {
        makeTransactionByReference(reference) {
            if(this.transaction.id) {
                return
            }

            if(!reference) {
                this.transaction = this.initialize('credit')
                return
            }

            this.transaction.transfer_reference = reference
            this.loading = true
            this.transaction.make((data) => {
                this.loading = false
            }).catch(error => {
                this.loading = false
            })
        },
        saveTransaction() {
            this.transaction.id ? this.editTransaction() : this.addTransaction()
        },
        addTransaction() {
            this.loading = true
            this.transaction.create((data) => {
                this.loading = false
                this.showModal = false
                this.$emit('created', data)
            }).catch(error => {
                this.loading = false
            })
        },
        editTransaction() {
            let isThirdParty = this.transaction.rebit_account_id.label && this.transaction.rebit_account_id.label.includes('Third-party')
            let dialogMessage = isThirdParty ? {
                title: 'Third-party Pair Transaction',
                message: 'Only STATUS and AMOUNT fields are copied to the pair.',
                ok: 'OK',
                cancel: 'CANCEL'
            }:{
                title: 'Edit Transaction',
                message: 'Are you sure?',
                ok: 'Yes',
                cancel: 'No'
            }

            this.$q.dialog(dialogMessage).onOk(() => {
                this.loading = true
                this.transaction.update((data) => {
                    this.loading = false
                    this.showModal = false
                    this.$emit('updated', data)
                }).catch(error => {
                    this.loading = false
                })
            }).onCancel(() => {
                this.loading = false
            })
        },
        fetchTransactionToEdit() {
            this.transaction.id = this.transactionId
            this.loading = true
            this.transaction.fetch(transaction => {
                this.loading = false
            }).catch(error => {
                this.loading = false
                this.$q.notify({
                    message: 'An error has occurred!',
                    color: 'negative'
                });
                this.$router.push({name: 'transaction.incoming'})
            })
        },
        fetchReferences() {
            this.loading = true
            Transfer.references('incoming', (data) => {
                this.loading = false
                this.references = data
            }).catch(error => {
                this.loading = false
            })
        },
    },
    created() {},
    mounted() {},
    watch: {
        showModal(val) {
            this.transaction = this.initialize( 'credit')
            if(val) {
                this.fetchReferences()
            }
            if(val && this.transactionId) {
                this.references = []
                this.fetchTransactionToEdit()
            }
            if(val && this.reference) {
                this.makeTransactionByReference(this.reference)
            }
        },
    },
    components: {
        IncomingTransactionForm,
    },
}
</script>
